import { Injectable } from '@angular/core';

import { combineEpics } from 'redux-observable';
import { catchError } from 'rxjs/operators';

import { AccountTicketsEpics } from './account-tickets';
import { ChangePasswordEpics, LoginEpics, RecoverPasswordEpics } from './auth/+state';
import { BankcardTicketsEpics } from './bankcard-tickets/+state';
import { CustomerEpics } from './customer/+state';
import { IsicCardEpic } from './isic-card/+state/isic-card.epic';
import { PaymentMethodsEpics } from './payment-methods/+state';
import { PersonalizeEpics } from './personalize';
import { ProductCategoriesEpics } from './product-categories';
import { ProductsEpics } from './products';
import { PurchaseHistoryEpics } from './purchase-history/+state';
import { RealtimeEpics } from './realtime/+state/realtime.epic';
import { RelatedCardEpics } from './related-card/+state';
import { RideBookingsEpics } from './ride-bookings';
import { RideHistoryEpics } from './ride-history';
import { RidePlannerEpics } from './ride-planner/+state';
import { ScheduleEpics } from './schedule/+state/schedule.epics';
import { ShoppingCartEpics } from './shopping-cart/+state';
import { StopsEpics } from './stops/+state';
import { SwishEpics } from './swish/+state';
import { ValidationHistoryEpics } from './validation-history';
import { PurchaseEpic } from './purchase/+state/purchase.epic';

@Injectable({
    providedIn: 'root'
})
export class ComponentsService {
    constructor(
        private loginEpics: LoginEpics,
        private recoverPasswordEpics: RecoverPasswordEpics,
        private changePasswordEpics: ChangePasswordEpics,
        private customerEpics: CustomerEpics,
        private purchaseHistoryEpics: PurchaseHistoryEpics,
        private relatedCardEpics: RelatedCardEpics,
        private ridePlannerEpics: RidePlannerEpics,
        private accountTicketsEpics: AccountTicketsEpics,
        private productsEpics: ProductsEpics,
        private shoppingCartEpics: ShoppingCartEpics,
        private paymentMethodEpics: PaymentMethodsEpics,
        private swishEpics: SwishEpics,
        private productCategoriesEpics: ProductCategoriesEpics,
        private stopsEpics: StopsEpics,
        private realtimeEpics: RealtimeEpics,
        private validationHistoryEpics: ValidationHistoryEpics,
        private scheduleEpics: ScheduleEpics,
        private rideHistoryEpics: RideHistoryEpics,
        private rideBookingsEpics: RideBookingsEpics,
        private bankcardTicketsEpics: BankcardTicketsEpics,
        private personalizeEpics: PersonalizeEpics,
        private isicCardEpics: IsicCardEpic,
        private purchaseEpics: PurchaseEpic
    ) {}

    getRootEpic() {
        // array holds list of all epics in this module
        const epics = [].concat(
            this.loginEpics.register(),
            this.recoverPasswordEpics.register(),
            this.changePasswordEpics.register(),
            this.customerEpics.register(),
            this.purchaseHistoryEpics.register(),
            this.relatedCardEpics.register(),
            this.ridePlannerEpics.register(),
            this.accountTicketsEpics.register(),
            this.productsEpics.register(),
            this.shoppingCartEpics.register(),
            this.paymentMethodEpics.register(),
            this.swishEpics.register(),
            this.productCategoriesEpics.register(),
            this.stopsEpics.register(),
            this.purchaseEpics.register(),
            this.realtimeEpics.register(),
            this.validationHistoryEpics.register(),
            this.scheduleEpics.register(),
            this.rideHistoryEpics.register(),
            this.rideBookingsEpics.register(),
            this.bankcardTicketsEpics.register(),
            this.personalizeEpics.register(),
            this.isicCardEpics.register()
        );

        const rootEpic = (action$, store$, dependencies) =>
            combineEpics(...epics)(action$, store$, dependencies).pipe(
                // global error handler to that catches uncaught errors and resubscribes to the source stream.
                // see: https://redux-observable.js.org/docs/basics/SettingUpTheMiddleware.html#adding-global-error-handler
                catchError((error, source) => {
                    console.error(error);
                    return source;
                })
            );

        return rootEpic;
    }
}
